import { render } from "./PROPOSAL_UPDATED_MAJOR.vue?vue&type=template&id=1a0c9944"
import script from "./PROPOSAL_UPDATED_MAJOR.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_UPDATED_MAJOR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__